import React from 'react';
import { X, Trophy } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface HomequestBannerProps {
  onDismiss: () => void;
  dataSource?: string;
}

export const HomequestBanner: React.FC<HomequestBannerProps> = ({ 
  onDismiss,
  dataSource = 'HomeQuest game'
}) => {
  return (
    <Alert className="bg-gradient-to-r from-orange-50 to-red-50 border-orange-200 mb-6 relative">
      <div className="flex items-start gap-3">
        <Trophy className="h-5 w-5 text-orange-600 mt-0.5 flex-shrink-0" />
        <AlertDescription className="flex-1">
          <div className="font-semibold text-orange-900 mb-1">
            🎮 HomeQuest Data Loaded
          </div>
          <div className="text-sm text-orange-800">
            Your profile from <strong>{dataSource}</strong> has been imported! We've pre-filled the calculator with your answers. Feel free to review and adjust any values.
          </div>
        </AlertDescription>
        <button
          onClick={onDismiss}
          className="text-orange-400 hover:text-orange-600 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </Alert>
  );
};
